import ReferenciaDto from '../domain/ReferenciaDto'

export default class UpdateReferenciasEnlaceC3 {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, referencia) {
    try {
      const dto = new ReferenciaDto().fromEntity(referencia)
      dto.fk_idPersonal = idPersonal

      await this.#repository.update(idPersonal, referencia.id, dto)
    } catch (error) {
      throw error
    }
  }
}
